export default "__VITE_ASSET__CaDUHZqh__"